module.exports = __webpack_public_path__ + "media/images/icons/time-2cdc9b9497f2dd6b138bba3e2f8f6453.svg";